import React, { useState } from 'react';
// import { store } from '../../../index';
// import { checkReport } from '../../../actions/ApartmentActions';
import MoreInfoComponent from './MoreInfoComponent';
import ApartmentTenantComponent from './ApartmentTenantComponent';

function ApartmentTableRowComponent(props) {
    const [showInfo, setShowInfo] = useState(false);

    const toggleShowInfo = () => {
        setShowInfo(!showInfo);
    };

    var tenants = props.apartment.apartmentTenants.map(function (apartmentTenant) {
        return (<React.Fragment key={apartmentTenant.id}>
            <ApartmentTenantComponent apartmentTenant={apartmentTenant} warning={props.apartment.apartmentTenants.length > 2 ? "table-warning" : ""} toggleShowInfo={toggleShowInfo}></ApartmentTenantComponent>
        </React.Fragment>)
    });
    // var tenants = <tbody><tr></tr></tbody>;
    
    return (
            <React.Fragment >
                <tr className={"according-toggle clickMobile"} data-toggle='collapse' data-target={"#" + props.apartment.number}  >
                    <td onClick={() => setShowInfo(!showInfo)} style={{ textAlign: "center" }}>{props.apartment.number} </td>
                    <td onClick={() => setShowInfo(!showInfo)} >{props.apartment.address} {props.apartment.postcode} {props.apartment.suburb}</td>
                    <table onClick={() => setShowInfo(!showInfo)} className="table table-responsive table-striped table-hover">
                        {tenants}{/* all tenants for this apartment */}
                    </table>

                    <td style={{ textAlign: "center" }}>
                        <input type="checkbox" checked={props.report.includes(props.apartment.id)}
                            onChange={(event) => {
                                if(event.target.checked){
                                    props.addToReportList(props.apartment.id);
                                } else {
                                    props.removeFromReportList(props.apartment.id);
                                }
                                // setShowInfo({ ["report_" + props.apartment.id]: event.target.checked });
                                // props.apartment["report_" + props.apartment.id] = event.target.checked;
                                // store.dispatch(checkReport(props.apartment))
                            }} />
                    </td>
                    <td onClick={() => setShowInfo(!showInfo)} style={{ textAlign: "center" }}><span className={props.apartment.for_sale ? 'bi bi-check-circle' : 'bi bi-circle-fill'}>&nbsp;</span></td>
                </tr>
                {showInfo ? <MoreInfoComponent apartment={props.apartment}></MoreInfoComponent> : <div></div>}
            </React.Fragment >
        );
}

export default ApartmentTableRowComponent;